import { render, staticRenderFns } from "./NewsAnyTag.vue?vue&type=template&id=732c9972&"
import script from "./NewsAnyTag.vue?vue&type=script&lang=js&"
export * from "./NewsAnyTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports